import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { ListTable } from 'gnos-tables'
import _ from 'lodash'

import Signals from '../../../../../../../../../../../../../components/TableCell/components/Signals'
import CustomDate from '../../../../../../../../../../../../../components/CustomDate'
import Entity from '../../../../../../../../../../../../../components/TableCell/components/Entity'
import CellStyleWrapper from '../../../../../../../../../../../../../components/TableCell/components/CellStyleWrapper'

import { LOCALE_PREFIX } from '../../../../constants'
import './style.scss'

export default class SubTable extends Component {
    static propTypes = {
        creditors: PropTypes.array,
        debtors: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        rowIndex: PropTypes.number,
    }

    getColumnDefinitions = (selector) => {
        const { intl } = this.props

        return {
            title: {
                Cell: (value) => (
                    <CellStyleWrapper isNotActive={value?.row?.inactive}>
                        <span>
                            {intl.formatMessage({
                                id: `${LOCALE_PREFIX}.${selector === 'debtor' ? 'debtorOther' : selector}`,
                            })}
                        </span>
                    </CellStyleWrapper>
                ),
                width: 100,
            },
            top: {
                columns: [
                    {
                        accessor: 'subject',
                        Cell: (value) => (
                            <Entity
                                entity={_.get(value, 'value', null)}
                                value={_.get(value, 'value.name')}
                                type={_.get(value, 'value.type')}
                                inactive={_.get(value, 'value.inactive')}
                                entId={_.get(value, 'value.id', null)}
                                rowInactive={_.get(value, 'original.inactive')}
                            />
                        ),
                    },
                    {
                        accessor: 'subject.indicators',
                        Cell: (value) => (
                            <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                <Signals
                                    id={_.get(value, 'original.subject.id', null)}
                                    notice={_.get(value, 'value.notice', 0)}
                                    risk={_.get(value, 'value.risk', 0)}
                                    caution={_.get(value, 'value.caution', 0)}
                                />
                            </CellStyleWrapper>
                        ),
                        width: 150,
                    },
                    {
                        accessor: 'startDate',
                        Cell: (value) =>
                            !_.isNil(_.get(value, 'value.value')) && (
                                <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                    <span>
                                        <FormattedMessage id={`${LOCALE_PREFIX}.from`} />
                                        <CustomDate date={_.get(value, 'value.value')} precision={'days'} />
                                    </span>
                                </CellStyleWrapper>
                            ),
                        width: 200,
                    },
                    {
                        accessor: 'endDate',
                        Cell: (value) =>
                            !_.isNil(_.get(value, 'value.value')) && (
                                <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                    <span>
                                        <FormattedMessage id={`${LOCALE_PREFIX}.to`} />
                                        <CustomDate date={_.get(value, 'value.value')} precision={'days'} />
                                    </span>
                                </CellStyleWrapper>
                            ),
                        width: 200,
                    },
                ],
            },
        }
    }

    render() {
        const { id, rowIndex, intl, creditors, debtors } = this.props

        return (
            <div className={'cac-liens-debtor-subtable'}>
                <div className={'table-title'}>{intl.formatMessage({ id: `${LOCALE_PREFIX}.creditors` })}</div>
                <div className={'creditors-table-container'}>
                    {_.isEmpty(creditors) && (
                        <div className={'no-list-table-data'}>
                            {intl.formatMessage({ id: `${LOCALE_PREFIX}.noCreditors` })}
                        </div>
                    )}
                    <ListTable
                        id={`liens-debtor-subtable-creditors-list-table-${id}-${rowIndex}`}
                        itemIdentifier={'subject.id'}
                        staticData={{
                            _table: [
                                {
                                    key: `liens-debtor-subtable-creditors-list-table-${id}-${rowIndex}`,
                                    tables: [
                                        {
                                            rows: creditors,
                                        },
                                    ],
                                },
                            ],
                        }}
                        texts={{
                            controlExpand: intl.formatMessage({ id: 'global.controlExpand' }),
                            controlMore: intl.formatMessage({ id: 'global.controlMore' }),
                            controlLess: intl.formatMessage({ id: 'global.controlLess' }),
                            controlAll: intl.formatMessage({ id: 'global.controlAll' }),
                            controlClose: intl.formatMessage({ id: 'global.controlClose' }),
                            controlFirst: intl.formatMessage({ id: 'global.controlFirst' }),
                        }}
                        columnsDefinition={this.getColumnDefinitions('creditor')}
                    />
                </div>
                <div className={'table-title'}>{intl.formatMessage({ id: `${LOCALE_PREFIX}.debtors` })}</div>
                <div className={'debtors-table-container'}>
                    {_.isEmpty(debtors) && (
                        <div className={'no-list-table-data'}>
                            {intl.formatMessage({ id: `${LOCALE_PREFIX}.noDebtors` })}
                        </div>
                    )}
                    <ListTable
                        id={`liens-debtor-subtable-debtors-list-table-${id}-${rowIndex}`}
                        itemIdentifier={'subject.id'}
                        staticData={{
                            _table: [
                                {
                                    key: `liens-debtor-subtable-debtors-list-table-${id}-${rowIndex}`,
                                    tables: [
                                        {
                                            rows: debtors,
                                        },
                                    ],
                                },
                            ],
                        }}
                        texts={{
                            controlExpand: intl.formatMessage({ id: 'global.controlExpand' }),
                            controlMore: intl.formatMessage({ id: 'global.controlMore' }),
                            controlLess: intl.formatMessage({ id: 'global.controlLess' }),
                            controlAll: intl.formatMessage({ id: 'global.controlAll' }),
                            controlClose: intl.formatMessage({ id: 'global.controlClose' }),
                            controlFirst: intl.formatMessage({ id: 'global.controlFirst' }),
                        }}
                        columnsDefinition={this.getColumnDefinitions('debtor')}
                    />
                </div>
            </div>
        )
    }
}
